import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SpaRedirect — crawler-friendly 301-style redirect for deleted/nonexistent
 * dynamic pages (removed blog posts, unknown location slugs).
 *
 * Instead of rendering a 200 + noindex "Not Found" screen (which Google files
 * under "Excluded by noindex" / "Soft 404" forever), we send the URL to its
 * parent index. We expose the decision to crawlers via a canonical + meta
 * refresh and then hard-replace the location for real users. This makes Google
 * reclassify the dead URL as a clean "Page with redirect" and drop it quickly.
 *
 * Only use this on a DEFINITIVE 404 — never on transient/5xx errors.
 */
const SpaRedirect = ({ to = '/', message = 'Redirecting…' }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace(to);
    }
  }, [to]);

  const abs = `https://fortworthdental.com${to}`;
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={abs} />
        <meta httpEquiv="refresh" content={`0; url=${to}`} />
      </Helmet>
      <section
        data-testid="spa-redirect"
        data-redirect-to={to}
        className="min-h-[50vh] flex items-center justify-center"
      >
        <p className="text-gray-500">{message}</p>
      </section>
    </>
  );
};

export default SpaRedirect;
